import { Button, Col, Row, Container, Table } from 'react-bootstrap';
import toast, { Toaster } from "react-hot-toast";
import { useState, useEffect } from 'react';
import '../../css/common.css';
import '../../css/hover.css'
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { saveForm, deleteForm } from '../../store/Slices/formSlice';
import useValidation from '../../helpers/validation';
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload, faTrash, faDownload } from '@fortawesome/free-solid-svg-icons';

function TollfreeFrench() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userEmail = sessionStorage.getItem('email');

    useEffect(() => {
        const fetchData = async () => {
            if (!userEmail) {
                navigate('/');
                return;
            }
            const form = JSON.parse(localStorage.getItem('form'));

            if (form?.country?.country === 'TollfreeFrench') {
                fillForm(form);
            }
        };

        fetchData();
    }, [dispatch, navigate]);

    const { validateInput, validationStates, setValidationStates } = useValidation();

    const [operator, setOperator] = useState('');
    const [address, setAddress] = useState('');
    const [city, setCity] = useState('');
    const [zip, setZip] = useState('');

    const [custName, setCustName] = useState('');
    const [vat, setVat] = useState('');
    const [custAddress, setCustAddress] = useState('');
    const [custCity, setCustCity] = useState('');
    const [custZip, setCustZip] = useState('');
    const [accNum, setAccNum] = useState('');
    const [mbn, setMbn] = useState('');
    const [sign, setSign] = useState('');
    const [date, setDate] = useState('');
    const [printName, setPrintName] = useState('');
    const [position, setPosition] = useState('');
    const [contactNumber, setContactNumber] = useState('');

    //-----------------------------------------------FillForm-------------------------------------------------//

    const fillForm = (form) => {
        const JSONDATA = form;

        setOperator(JSONDATA?.country?.operatorDetails?.operator ?? '');
        setAddress(JSONDATA?.country?.operatorDetails?.address ?? '');
        setCity(JSONDATA?.country?.operatorDetails?.city ?? '');
        setZip(JSONDATA?.country?.operatorDetails?.zip ?? '');
        document.querySelector('#operator').value = JSONDATA?.country?.operatorDetails?.operator ?? '';
        document.querySelector('#address').value = JSONDATA?.country?.operatorDetails?.address ?? '';
        document.querySelector('#city').value = JSONDATA?.country?.operatorDetails?.city ?? '';
        document.querySelector('#zip').value = JSONDATA?.country?.operatorDetails?.zip ?? '';

        setCustName(JSONDATA?.country?.clientDetails?.custName ?? '');
        setVat(JSONDATA?.country?.clientDetails?.vat ?? '');
        setCustAddress(JSONDATA?.country?.clientDetails?.custAddress ?? '');
        setCustCity(JSONDATA?.country?.clientDetails?.custCity ?? '');
        setCustZip(JSONDATA?.country?.clientDetails?.custZip ?? '');
        setAccNum(JSONDATA?.country?.clientDetails?.accNum ?? '');

        document.querySelector('#custName').value = JSONDATA?.country?.clientDetails?.custName ?? '';
        document.querySelector('#vat').value = JSONDATA?.country?.clientDetails?.vat ?? '';
        document.querySelector('#custAddress').value = JSONDATA?.country?.clientDetails?.custAddress ?? '';
        document.querySelector('#custCity').value = JSONDATA?.country?.clientDetails?.custCity ?? '';
        document.querySelector('#custZip').value = JSONDATA?.country?.clientDetails?.custZip ?? '';
        document.querySelector('#accNum').value = JSONDATA?.country?.clientDetails?.accNum ?? '';

        setTableDataRange(JSONDATA?.country?.customer?.tableDataRange ?? []);
        setMbn(JSONDATA?.country?.customer?.mbn ?? '');
        setSign(JSONDATA?.country?.customer?.sign ?? '');
        setDate(JSONDATA?.country?.customer?.date ?? '');
        setPrintName(JSONDATA?.country?.customer?.printName ?? '');
        setPosition(JSONDATA?.country?.customer?.position ?? '');
        setContactNumber(JSONDATA?.country?.customer?.contactNumber ?? '');
        document.querySelector('#mbn').value = JSONDATA?.country?.customer?.mbn ?? '';
        document.querySelector('#sign').value = JSONDATA?.country?.customer?.sign ?? '';
        document.querySelector('#date').value = JSONDATA?.country?.customer?.date ?? '';
        document.querySelector('#printName').value = JSONDATA?.country?.customer?.printName ?? '';
        document.querySelector('#position').value = JSONDATA?.country?.customer?.position ?? '';
        document.querySelector('#contactNumber').value = JSONDATA?.country?.customer?.contactNumber ?? ''

    }

    //-----------------------------------------------Hover-------------------------------------------------//

    const [hoveredField, setHoveredField] = useState(null); //hovered field

    const handleMouseEnter = (field) => {
        setHoveredField(field);
    };

    const handleMouseLeave = () => {
        setHoveredField(null);
    };

    //--------------------------------table declaration (DID Range)--------------------------------------//

    const [tableDataRange, setTableDataRange] = useState([{ id: Date.now(), sNumber: '', eNumber: '' }]);

    //adding a row
    const addRow_range = () => {
        setTableDataRange([...tableDataRange, { id: Date.now(), sNumber: '', eNumber: '' }]);
    };

    //removing a row
    const removeRow_range = (id) => {
        setTableDataRange(tableDataRange.filter(row => row.id !== id));
    };

    //change handler of table
    const handleChange_tableRange = (id, key, value) => {
        const updatedData = tableDataRange.map(row => {
            if (row.id === id) {
                return { ...row, [key]: value };
            }
            return row;
        });
        setTableDataRange(updatedData);
    };

    const fileInputRef = React.createRef();  // Create a reference to the file input element
    const [uploadedFileName, setUploadedFileName] = useState('');

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        setUploadedFileName(file.name);

        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];

            // Read headers from row 5 (0-indexed, so index 4)
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1, range: 4 });
            if (!jsonData.length) {
                toast.error('Uploaded file is empty or has an invalid format.');
                setUploadedFileName('');
                return;
            }

            const fileHeaders = jsonData[0] || [];
            const expectedHeaders = ['Public from', 'Public to', 'Private from', 'Private to', 'Local Country Value'];

            // Check if headers match
            if (!expectedHeaders.every((header, index) => header === fileHeaders[index])) {
                toast.error('Uploaded file does not match the expected format.');
                setUploadedFileName('');
                return;
            }

            // Read actual data from row 6 onwards
            const dataRows = jsonData.slice(1);

            // Extract relevant data for tableDataRange
            const formattedDataRange = dataRows.map((row, index) => ({
                id: index + 1,
                sNumber: row[0] ? row[0].toString() : '',
                eNumber: row[1] ? row[1].toString() : '',
            }));

            setTableDataRange(formattedDataRange);

            // Validate each row: must be numeric and not empty
            formattedDataRange.forEach(row => {
                const isStartValid = /^[0-9]+$/.test(row.sNumber);
                const isEndValid = /^[0-9]+$/.test(row.eNumber);

                setValidationStates(prev => ({
                    ...prev,
                    [`startNumber-${row.id}`]: isStartValid,
                    [`endNumber-${row.id}`]: isEndValid,
                }));
            });
        };

        reader.readAsArrayBuffer(file);
    };

    const removeUploadedFile = () => {
        setUploadedFileName('');
        fileInputRef.current.value = '';
        setTableDataRange([{ id: Date.now(), sNumber: '', eNumber: '' }]);
    };

    const handleDownload = async () => {
        try {
            // Fetch the file (portabilityImportTemplate.xlsx) from the server
            const response = await fetch(`/portabilityImportTemplate.xlsx?t=${new Date().getTime()}`);

            // Check if the response is valid
            if (!response.ok) throw new Error("Network response was not ok");

            // Convert the response to a Blob
            const blob = await response.blob();

            // Create a URL for the Blob to allow it to be downloaded
            const url = window.URL.createObjectURL(blob);

            // Create an anchor tag dynamically and trigger a click to download the file
            const a = document.createElement("a");
            a.href = url;
            a.download = "portabilityImportTemplate.xlsx"; // File name for download
            document.body.appendChild(a);
            a.click(); // Initiate the download
            document.body.removeChild(a); // Clean up by removing the anchor element
        } catch (error) {
            // Catch any error that occurs during the download process
            console.error("Download failed:", error);
        }
    };

    //-------------------------------------------creating Schema----------------------------------------//

    const json = {
        "country": {
            "country": "TollfreeFrench",

            "operatorDetails": {
                "operator": operator,
                "address": address,
                "city": city,
                "zip": zip
            },

            "clientDetails": {
                "custName": custName,
                "vat": vat,
                "custAddress": custAddress,
                "custCity": custCity,
                "custZip": custZip,
                "accNum": accNum
            },

            "customer": {
                "tableDataRange": tableDataRange,
                "mbn": mbn,
                "sign": sign,
                "date": date,
                "printName": printName,
                "position": position,
                "contactNumber": contactNumber
            },
        },
        "email": sessionStorage.getItem('email'),
    };

    const jsonString = JSON.stringify(json);
    console.log(jsonString);

    //-----------------------------------------sending request---------------------------------------------//

    async function Submit(e) {
        let validationErrors = {};

        if (!operator) {
            validationErrors.operator = 'Veuillez remplir le nom de l’opérateur';
        }
        if (!address) {
            validationErrors.address = 'Veuillez remplir l’adresse';
        }
        if (!city) {
            validationErrors.city = 'Veuillez remplir la ville';
        }
        if (!zip) {
            validationErrors.zip = 'Veuillez remplir le code postal';
        }
        if (!custName) {
            validationErrors.custName = 'Veuillez remplir le nom du client';
        }
        if (!custAddress) {
            validationErrors.custAddress = 'Veuillez remplir l’adresse';
        }
        if (!custCity) {
            validationErrors.custCity = 'Veuillez remplir la ville';
        }
        if (!custZip) {
            validationErrors.custZip = 'Veuillez remplir le code postal';
        }
        if (!accNum) {
            validationErrors.accNum = 'Veuillez remplir le numéro de compte';
        }

        // Ensure both Start Number and End Number are provided in Range Table
        tableDataRange.forEach(row => {
            const startId = `startNumber-${row.id}`;
            const endId = `endNumber-${row.id}`;

            // Validate start number
            if (!row.sNumber) {
                validationErrors[startId] = 'Veuillez remplir le début de la plage de numéros.';
            } else if (!/^[0-9]+$/.test(row.sNumber)) {
                validationErrors[startId] = 'Le numéro de début doit être numérique.';
            }

            // Validate end number
            if (!row.eNumber) {
                validationErrors[endId] = 'Veuillez remplir la fin de la plage de numéros.';
            } else if (!/^[0-9]+$/.test(row.eNumber)) {
                validationErrors[endId] = 'Le numéro de fin doit être numérique.';
            }
        });

        if (!sign) {
            validationErrors.sign = 'Veuillez remplir le nom du signataire';
        }
        if (!date) {
            validationErrors.date = 'Veuillez remplir la date';
        }
        if (!printName) {
            validationErrors.printName = 'Veuillez remplir le nom du contact en lettres moulées';
        }
        if (!contactNumber) {
            validationErrors.contactNumber = 'Veuillez remplir le numéro de contact';
        }

        const hasValidationError = Object.values(validationErrors).length > 0;

        if (hasValidationError) {
            // Update validation states
            setValidationStates(prevState => ({
                ...prevState,
                ...Object.keys(validationErrors).reduce((acc, key) => {
                    acc[key] = false;
                    return acc;
                }, {})
            }));

            // Show the first error message and scroll to the field if it exists
            const firstError = Object.values(validationErrors)[0];
            const firstErrorKey = Object.keys(validationErrors)[0];
            const firstErrorElement = document.getElementById(firstErrorKey);

            if (firstErrorElement) {
                firstErrorElement.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            } else {
                console.error(`Element with ID ${firstErrorKey} not found.`);
                toast.error("Une erreur s'est produite lors du défilement vers le champ invalide.");
            }

            toast.error(firstError);
            return;
        }

        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => value === false)
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            toast.error(`Veuillez vous assurer que les champs en rouge sont corrects. \n${falseKeys}`);
            const elem = document.getElementById(falseKeys[0]);
            if (elem) {
                elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            } else {
                console.error(`Element with ID ${falseKeys[0]} not found.`);
            }
            return;
        }

        // If all validations pass, proceed with the form submission
        e.preventDefault();
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/generate_loa`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                },
                body: jsonString
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blobData = await response.blob();
            const url = URL.createObjectURL(blobData);
            const a = document.createElement('a');
            a.href = url;
            a.download = operator + '-LOA.docx';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Error downloading file: ', error);
            window.location.href = 'https://my-service-space.orange-business.com/wacsmss/group/mssportal/home';
        }
    }

    //----------------------------------------------RESET--------------------------------------------------//

    async function Reset(e) {
        const dataToBeDeleted = { "email": userEmail };
        dispatch(deleteForm(dataToBeDeleted));
        localStorage.removeItem('form');
        window.location.reload();
    }

    // ----------------------------------------------SAVE--------------------------------------------------//

    async function save(e) {
        e.preventDefault();
        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => {
                const element = document.getElementById(key);
                return value === false && element && element.value.trim() !== '';
            })
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            const elem = document.getElementById(falseKeys[0]);
            elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            toast.error(`Please make sure following fields in red are correct before saving `);
            return;
        }

        localStorage.setItem('form', JSON.stringify(json));
        const dataToBeSaved = { "email": userEmail, "json_data": json };
        try {
            const response = await dispatch(saveForm(dataToBeSaved));
            if (response?.payload?.message === "success") {
                toast.success('Form saved successfully');
            }
        } catch (error) {
            toast.error('There was an error processing your request.');
        }
    }

    //-----------------------------------------------JSX----------------------------------------------------//

    return (
        <div>

            <Toaster position="top-center" reverseOrder={false}></Toaster>

            <div className='french'>

                <p><strong>Mandatory fields are marked by *</strong></p>

                <Container>

                    <h2 className='heading'>Opérateur donneur / Opérateur cédant</h2> <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('operator')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Nom de l’opérateur*</label> <br />
                            <input
                                onChange={(e) => setOperator(e.target.value)}
                                type="text"
                                id='operator'
                                placeholder=""
                                className={`inputbox ${validationStates.operator === false ? 'error' : ''}`}
                                onBlur={() => validateInput('operator', /[a-zA-Z0-9]/)}
                            />

                            {hoveredField === 'operator' && (
                                <div className="hover-description">
                                    Entrez le nom de l'opérateur.
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('address')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Adresse*</label>
                            <input
                                onChange={(e) => setAddress(e.target.value)}
                                type="text"
                                id="address"
                                placeholder=""
                                className={`inputbox ${validationStates.address === false ? 'error' : ''}`}
                                onBlur={() => validateInput('address', /[a-zA-Z0-9]/)}
                            />

                            {hoveredField === 'address' && (
                                <div className="hover-description">
                                    Entrez l'adresse.
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('city')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Ville*</label>
                            <input
                                onChange={(e) => setCity(e.target.value)}
                                type="text"
                                id="city"
                                placeholder=""
                                className={`inputbox ${validationStates.city === false ? 'error' : ''}`}
                                onBlur={() => validateInput('city', /[a-zA-Z0-9]/)}
                            />

                            {hoveredField === 'city' && (
                                <div className="hover-description">
                                    Entrez Ville.
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('zip')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Code postal*</label>
                            <input
                                onChange={(e) => setZip(e.target.value)}
                                type="text"
                                id="zip"
                                placeholder=""
                                className={`inputbox ${validationStates.zip === false ? 'error' : ''}`}
                                onBlur={() => validateInput('zip', /[a-zA-Z0-9]/)}
                            />

                            {hoveredField === 'zip' && (
                                <div className="hover-description">
                                    Entrez Zip.
                                </div>
                            )}
                        </Col>
                    </Row>

                </Container>

                <br></br><br></br>

                <Container>

                    <h2 className='heading'>Détails du client</h2> <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('custName')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label style={{ display: 'block', height: '52px' }}>
                                Nom du client*
                            </label>

                            <input
                                onChange={(e) => setCustName(e.target.value)}
                                type="text"
                                id='custName'
                                placeholder=""
                                className={`inputbox ${validationStates.custName === false ? 'error' : ''}`}
                                onBlur={() => validateInput('custName', /[a-zA-Z0-9]/)}
                            />

                            {hoveredField === 'custName' && (
                                <div className="hover-description">
                                    Entrez le nom du client
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('vat')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label style={{ display: 'block', height: '52px' }}>
                                Numéro de TVA / Numéro d’immatriculation
                            </label>

                            <input
                                onChange={(e) => setVat(e.target.value)}
                                type="text"
                                id="vat"
                                placeholder=""
                                className={`inputbox`}
                            />

                            {hoveredField === 'vat' && (
                                <div className="hover-description">
                                    Saisissez votre numéro de TVA/d'immatriculation.
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('custAddress')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label style={{ display: 'block', height: '52px' }}>
                                Adresse*
                            </label>

                            <input
                                onChange={(e) => setCustAddress(e.target.value)}
                                type="text"
                                id="custAddress"
                                placeholder=""
                                className={`inputbox ${validationStates.custAddress === false ? 'error' : ''}`}
                                onBlur={() => validateInput('custAddress', /[a-zA-Z0-9]/)}
                            />

                            {hoveredField === 'custAddress' && (
                                <div className="hover-description">
                                    Entrez l'adresse.
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('custCity')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Ville*</label>
                            <input
                                onChange={(e) => setCustCity(e.target.value)}
                                type="text"
                                id="custCity"
                                placeholder=""
                                className={`inputbox ${validationStates.custCity === false ? 'error' : ''}`}
                                onBlur={() => validateInput('custCity', /[a-zA-Z0-9]/)}
                            />

                            {hoveredField === 'custCity' && (
                                <div className="hover-description">
                                    Entrez Ville.
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('custZip')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Code postal*</label>
                            <input
                                onChange={(e) => setCustZip(e.target.value)}
                                type="text"
                                id="custZip"
                                placeholder=""
                                className={`inputbox ${validationStates.custZip === false ? 'error' : ''}`}
                                onBlur={() => validateInput('custZip', /[a-zA-Z0-9]/)}
                            />

                            {hoveredField === 'custZip' && (
                                <div className="hover-description">
                                    Entrez Zip.
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('accNum')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Numéro de compte client auprès de l’opérateur cédant*</label>
                            <p>(*tel qu’indiqué sur la facture de télécommunications la plus récente de l’opérateur cédant)</p>
                            <input
                                onChange={(e) => setAccNum(e.target.value)}
                                type="text"
                                id="accNum"
                                placeholder=""
                                className={`inputbox ${validationStates.accNum === false ? 'error' : ''}`}
                                onBlur={() => validateInput('accNum', /[a-zA-Z0-9]/)}
                            />

                            {hoveredField === 'accNum' && (
                                <div className="hover-description">
                                    Entrez le numéro de compte.
                                </div>
                            )}
                        </Col>
                    </Row>

                </Container>

                <br></br><br></br>

                <Container>
                    <p><strong>Remarque : Ce document autorise le transfert des numéros ci-dessous.</strong></p>

                    <h4 className='text-decoration-underline'>Number Range</h4> <br></br>

                    {/* <Row>
                        <Col>
                            <button className="inputbox" onClick={handleDownload} style={{ alignItems: 'center' }}>
                                <FontAwesomeIcon icon={faDownload} style={{ marginRight: '8px' }} />
                                Télécharger le modèle de tranche de numéros
                            </button>
                        </Col>

                        <Col>
                            <button
                                variant="secondary"
                                className="inputbox"
                                style={{ alignItems: 'center' }}
                                onClick={() => fileInputRef.current.click()}
                            >
                                <FontAwesomeIcon icon={faUpload} style={{ marginRight: '8px' }} />
                                Télécharger le fichier
                            </button>
                            <input
                                id="fileUploadInput"
                                type="file"
                                accept=".xlsx, .xls"
                                onChange={handleFileUpload}
                                ref={fileInputRef}
                                style={{ display: 'none' }}
                            />
                        </Col>

                        <Col>
                            {uploadedFileName && (
                                <button onClick={removeUploadedFile} className="inputbox" style={{ alignItems: 'center' }}>
                                    <FontAwesomeIcon icon={faTrash} style={{ marginRight: '8px' }} />
                                    Retirer
                                </button>
                            )}
                        </Col>

                    </Row> */}

                    <Row>
                        <Col>
                            <button
                                className="inputbox"
                                onClick={handleDownload}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    minWidth: '100px', // Match the width to the first button
                                    marginRight: '300px'
                                }}
                            >
                                <FontAwesomeIcon icon={faDownload} style={{ marginRight: '8px' }} />
                                Télécharger le modèle de tranche de numéros
                            </button>
                        </Col>

                        <Col>
                            <button
                                variant="secondary"
                                className="inputbox"
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    minWidth: '280px' // Set a consistent width for both buttons
                                }}
                                onClick={() => fileInputRef.current.click()}
                            >
                                <FontAwesomeIcon icon={faUpload} style={{ marginRight: '8px' }} />
                                Télécharger le fichier
                            </button>
                            <input
                                id="fileUploadInput"
                                type="file"
                                accept=".xlsx, .xls"
                                onChange={handleFileUpload}
                                ref={fileInputRef}
                                style={{ display: 'none' }}
                            />
                        </Col>



                        <Col>
                            {uploadedFileName && (
                                <button onClick={removeUploadedFile} className="inputbox" style={{ alignItems: 'center' }}>
                                    <FontAwesomeIcon icon={faTrash} style={{ marginRight: '8px' }} />
                                    Retirer
                                </button>
                            )}
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            {uploadedFileName && (
                                <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                    <p style={{ marginRight: '10px' }}>Fichier téléchargé: {uploadedFileName}</p>
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br />
                    <p>
                        Le modèle est le même que celui utilisé pour la demande de portabilité BTD.</p>
                    <br />

                    <Table striped bordered hover variant="light">
                        <thead>
                            <tr>
                                <th>Début de la plage de numéros*</th>
                                <th>Fin de la plage de numéros*</th>
                            </tr>
                        </thead>

                        <tbody>

                            {tableDataRange.map(row => (
                                <tr key={row.id}>

                                    {/* Start Range */}
                                    <td
                                        onMouseEnter={() => handleMouseEnter(`startNumber-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`startNumber-${row.id}`}
                                            value={row.sNumber}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                handleChange_tableRange(row.id, 'sNumber', value);

                                                const isValid = /^[0-9]+$/.test(value);
                                                setValidationStates(prev => ({
                                                    ...prev,
                                                    [`startNumber-${row.id}`]: isValid,
                                                }));
                                            }}
                                            className={`inputbox ${validationStates[`startNumber-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={() => {
                                                const isValid = /^[0-9]+$/.test(row.sNumber);
                                                if (!isValid) {
                                                    toast.error('Only numeric input allowed and cannot be empty.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`startNumber-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />
                                        {hoveredField === `startNumber-${row.id}` && (
                                            <div className="hover-description">
                                                Saisissez le numéro de départ dans une plage
                                            </div>
                                        )}
                                        {validationStates[`startNumber-${row.id}`] === false && (
                                            <div className="error-message">
                                                Seules les données numériques sont autorisées et la saisie ne peut être vide.
                                            </div>
                                        )}
                                    </td>

                                    {/* End Number */}
                                    <td
                                        onMouseEnter={() => handleMouseEnter(`endNumber-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`endNumber-${row.id}`}
                                            value={row.eNumber}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                handleChange_tableRange(row.id, 'eNumber', value);

                                                const isValid = /^[0-9]+$/.test(value); // Exactly 11 digits
                                                setValidationStates(prev => ({
                                                    ...prev,
                                                    [`endNumber-${row.id}`]: isValid,
                                                }));
                                            }}
                                            className={`inputbox ${validationStates[`endNumber-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={() => {
                                                const isValid = /^[0-9]+$/.test(row.eNumber);
                                                if (!isValid) {
                                                    toast.error('Only numeric input allowed and cannot be empty.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`endNumber-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />
                                        {hoveredField === `endNumber-${row.id}` && (
                                            <div className="hover-description">
                                                Saisissez le numéro final dans une plage
                                            </div>
                                        )}
                                        {validationStates[`endNumber-${row.id}`] === false && (
                                            <div className="error-message">
                                                Seules les données numériques sont autorisées et la saisie ne peut être vide.
                                            </div>
                                        )}
                                    </td>

                                    <td>
                                        {tableDataRange.length > 1 && (
                                            <button onClick={() => removeRow_range(row.id)}>Retirer</button>
                                        )}
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </Table>
                    <button onClick={addRow_range}>Ajouter une ligne</button>

                    <br></br><br></br> <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('mbn')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label style={{ display: 'block', height: '52px' }}>
                                Numéro principal de facturation pour la plage
                            </label>

                            <input
                                onChange={(e) => setMbn(e.target.value)}
                                type="text"
                                id="mbn"
                                placeholder=""
                                className={`inputbox ${validationStates.mbn === false ? 'error' : ''}`}
                                onBlur={(e) => {
                                    const value = e.target.value.trim();
                                    const isValid = value === '' || /^[0-9]+$/u.test(value);
                                    setValidationStates(prev => ({ ...prev, mbn: isValid }));

                                    if (value !== '' && !isValid) {
                                        toast.error(
                                            'Seules les valeurs numériques sont autorisées.'
                                        );
                                    }
                                }}
                            />
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('sign')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label style={{ display: 'block', height: '52px' }}>
                                Signé par*
                            </label>

                            <input
                                onChange={(e) => setSign(e.target.value)}
                                type="text"
                                id="sign"
                                placeholder=""
                                className={`inputbox ${validationStates.sign === false ? 'error' : ''}`}
                                onBlur={() => validateInput('sign', /[a-zA-Z0-9]/)}
                            />

                            {hoveredField === 'sign' && (
                                <div className="hover-description">
                                    Veuillez saisir le nom de la personne autorisée.
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('date')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label style={{ display: 'block', height: '52px' }}>
                                Date*
                            </label>

                            <input
                                type="date"
                                id="date"
                                value={date}
                                onChange={(e) => setDate(e.target.value)}
                                min={new Date().toISOString().slice(0, 10)}
                                className={`inputbox ${validationStates.date === false ? 'error' : ''}`}
                                onBlur={() => validateInput('date', /^.*$/)}
                            />

                            {hoveredField === 'date' && (
                                <div className="hover-description">
                                    Entrez la date
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('printName')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Nom et prénom du contact*</label>
                            <input
                                onChange={(e) => setPrintName(e.target.value)}
                                type="text"
                                id="printName"
                                placeholder=""
                                className={`inputbox ${validationStates.printName === false ? 'error' : ''}`}
                                onBlur={() => validateInput('printName', /[a-zA-Z0-9]/)}
                            />

                            {hoveredField === 'printName' && (
                                <div className="hover-description">
                                    Saisir le nom du contact (en caractères d'imprimerie).
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('position')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Fonction dans l’entreprise</label>
                            <input
                                onChange={(e) => setPosition(e.target.value)}
                                type="text"
                                id="position"
                                placeholder=""
                                className={`inputbox`}
                            />

                            {hoveredField === 'position' && (
                                <div className="hover-description">
                                    Indiquez votre poste dans l'entreprise.
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('contactNumber')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Numéro de contact*</label>
                            <input
                                onChange={(e) => setContactNumber(e.target.value)}
                                type="text"
                                id="contactNumber"
                                placeholder=""
                                className={`inputbox ${validationStates.contactNumber === false ? 'error' : ''}`}
                                onBlur={() => validateInput('contactNumber', /[a-zA-Z0-9]/)}
                            />

                            {hoveredField === 'contactNumber' && (
                                <div className="hover-description">
                                    Entrez le numéro de contact.
                                </div>
                            )}
                        </Col>
                    </Row>
                </Container>

                <br></br><br></br>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Button variant="primary" type="save" onClick={save}>Save</Button>
                    <Button variant="primary" type="submit" onClick={Submit}>Generate LOA</Button>
                    {/* <Button variant="primary" type="autofill" onClick={autofill}>Autofill</Button> */}
                    <Button variant="primary" type="reset" onClick={Reset} style={{ marginRight: '20px' }}>Reset</Button>
                </div>
            </div>

        </div>
    );
}

export default TollfreeFrench;